import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { formatCurrency } from "../../Utils/Utils";
import { Button } from "primereact/button";

import commonStyle from "../../components/content/CommonStyles.module.css";

const ActPayments = ({ isMobile, payments, onUnbindClick}) => {

    console.log(payments);

    const paymentActionBodyTemplate = (rowData) => {
        return (<Button
            icon="pi pi-times"
            type="button"
            className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
            tooltip="Відв'язати платіж"
            tooltipOptions={{ position: "top" }}
            onClick={() => onUnbindClick(rowData.id)}
        />
        );
    }

    const paymentMobileDataBody = (rowData) => {
        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-12">
                        <div className="flex-column">
                            <div className="font-bold">ID Платежу: {rowData.id}</div>
                            <div>{rowData.cagent_name}</div>
                            <div>{rowData.date}</div>
                            <div>Сума: {formatCurrency(rowData.distribution_sum, rowData.currency)}</div>
                            <div>Еквівалент: {formatCurrency(rowData.distribution_sum_UAH, "UAH")}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {paymentActionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }

    return (
        !isMobile ? (
            <DataTable value={payments} emptyMessage="Платежів по акту не знайдено">
                <Column field="id" header="ID" style={{ width: '10%' }} />
                <Column field="date" header="Дата оплати" style={{ width: '20%' }} />
                <Column field="cagent_name" header="Контрагент" body={(rowData) => rowData.cagent_name === null ? "(Клієнта не вказано)" : rowData.cagent_name} style={{ width: '20%' }} />
                <Column field="distribution_sum" header="Сума" body={(rowData) => formatCurrency(rowData.distribution_sum, rowData.currency)} style={{ width: '20%' }} />
                <Column field="distribution_sum_UAH" header="Еквівалент, грн" body={(rowData) => formatCurrency(rowData.distribution_sum_UAH, "UAH")} style={{ width: '20%' }} />
                <Column field="action" body={paymentActionBodyTemplate} style={{ width: '10%' }} />
            </DataTable>
        ) : (
            <DataTable value={payments} emptyMessage="Платежів по акту не знайдено">
                <Column field="id" headerStyle={{ display: 'none' }} body={(rowData) => paymentMobileDataBody(rowData)} />
            </DataTable>
        )
    )
}

export default ActPayments;